module.exports = __webpack_public_path__ + "img/jobs.20fde29.png";